<h3 class="text-lg ml-2 mr-2">Zustazartikel wählen</h3>
<p class="color-light ml-2 mr-2">Es wurde festgestellt, dass das Produkt schwerer ist als geplant. Bitte
wählen Sie das verwendete Extra-Material aus, indem Sie auf das verwendete Material tippen!</p>

@if (loading()) {
  <div class="flex flex-row justify-center pt-2 pb-2 min-h">
    <soft-loading-spinner class="spin"></soft-loading-spinner>
  </div>
} @else {
  <div class="flex flex-col ml-2 mr-2 border-box mt-2">
    @if (legierungen(); as legierungen) {
      <div class="flex flex-row justify-between items-center mb-3 mt-3">
        <label for="select" class="mb-1" style="font-weight: 700">Legierung</label>
        <soft-select placeholder="Auswählen" id="select" [value]="selectedLegierung()"
          (valueChange)="selectedLegierung.set($event ?? null)">
          @for (legierung of legierungen; track legierung) {
            <soft-select-option [value]="legierung">
              {{ legierung?.charge }}
            </soft-select-option>
          }
        </soft-select>
      </div>
    }
    @if ((((legierungen()?.length ?? 0) > 0) && (selectedLegierung()))) {
      <strong class="mb-1 mt-3">Artikel</strong>
      @for (item of extraMaterials(); track item; let last = $last) {
        <div [class.border-b]="!last" (click)="close(item)"
          class="flex flex-row pt-2 pb-2 column center-v">
          @if (item?.cartikelnummer) {
            <span class="soft-overline">{{ item?.cartikelnummer }}</span>
          }
          <strong>{{ item?.artbez1 || '-' }}</strong>
          @if (item?.artbez2) {
            <span class="text-sm color-light">{{ item?.artbez2 }}</span>
          }
          @if (item?.artbez3) {
            <span class="text-sm color-light">{{ item?.artbez3 }}</span>
          }
        </div>
      }
    } @else {
      <div class="p-4">
        Bitte wählen Sie Zuerst eine Legierung aus
      </div>
    }
  </div>
}


<button class="soft-button secondary custom mt-3" (click)="close(null)">Abbrechen</button>
